// Feedback qualité sur les réponses de l'assistant IA (👍/👎 + commentaire).
// Le transcript complet part avec le feedback : c'est l'archivage de la
// conversation côté backend (table ai_feedback, jsonb).
import apiClient from "./apiClient";
import type { Message } from "@/store/slices/aiChatSlice";

export interface SubmitAiFeedbackPayload {
  sessionId: string | null;
  messageId: string;
  rating: "up" | "down";
  comment: string | null;
  conversation: Message[];
  generatedCode: string | null;
}

export async function submitAiFeedback(
  payload: SubmitAiFeedbackPayload,
): Promise<void> {
  await apiClient.post("/api/ai-feedback", payload);
}
